import { PRICING_SCHEME_UNIT } from './constants';

const DICTIONARIES = {
  en: {
    actual_unit_total_caption: '(Actual: {{total}} {{scheme}})',
    cod_fee: 'COD Fee',
    cod_fee_detail: 'Cod Fee Detail',
    empty_shipper_price_detail: {
      first_line_daily: 'Not applicable for Daily Rental pricing scheme.',
      first_line_monthly: 'Not applicable for Monthly Rental pricing scheme.',
      second_line: 'The calculation will based on per fleet.',
    },
    fee_configuration: 'Fee Configuration',
    fee_result: 'Fee Result',
    fee_result_captions: 'Not using COD service.',
    final_price_info: 'If specified, this value will override Shipper Price.',
    final_price: 'Final Price',
    flat: 'Flat',
    has_been_invoiced_in: {
      shipper_price: 'Shipper Price has been invoiced in',
      cod_fee: 'COD Fee has been invoiced in',
    },
    hour: 'Hour',
    min_value: 'Min. Value',
    other: 'Other',
    overidden_by_final_price: 'Overriden by Final Price',
    overtime_fee_per_hour: 'Overtime Fee per hour (Rp)',
    overtime: 'Overtime',
    percentage: 'Percentage',
    price_results: 'Price Results',
    price_rp: 'Price (Rp)',
    price: 'Price',
    price_summary: 'Price Summary',
    price_summary_caption: 'The price will appear after the shipment is completed',
    pricing_configuration: 'Pricing Configuration',
    pricing_scheme_unit: {
      [PRICING_SCHEME_UNIT.PER_CBM]: 'CBM',
      [PRICING_SCHEME_UNIT.PER_DROP_POINT]: 'drop',
      [PRICING_SCHEME_UNIT.PER_KM]: 'Km',
      [PRICING_SCHEME_UNIT.PER_LOAD]: 'Kg',
      [PRICING_SCHEME_UNIT.PER_ORDER]: 'order',
      [PRICING_SCHEME_UNIT.PER_ROUTE]: 'route',
      [PRICING_SCHEME_UNIT.RENTAL]: 'rental',
    },
    pricing_unit: 'Pricing / Unit',
    scheme: 'Scheme',
    shipper_price: 'Shipper Price',
    shipper_project: 'Shipper Project',
    total_collected_cod: 'Total Collected COD',
    total_fleet: 'Total Fleet',
    type: 'Type',
    unit: 'Unit',
    unit_value: 'Unit Value',
    value: 'Value',
  },
};

export default DICTIONARIES;
